import { LOGIN_REDIRECT_PARAM } from '@/views/FlowRun/flow-run.const';

const redirectToLogin = (baseUrl: string) => {
	const url = new URL('login', baseUrl);
	url.searchParams.set(LOGIN_REDIRECT_PARAM, window.location.href);
	window.location.replace(url.toString());
};

export const useRedirectToLogin = () => ({ redirectToLogin });
